import Mock from "mockjs";
export default {
  getData: config => {
    const payload = JSON.parse(config.body);
    const recordsTotal = 28; // 总记录条数
    const pageNo = parseInt(payload.pageNo); // 当前页
    const pageSize = parseInt(payload.pageSize); // 每页的条数
    const total = Math.ceil(recordsTotal / pageSize);
    const data = {};
    data.data = {
      treeData: [],
      pageNum: 1,
      pageSize: pageSize,
      size: 30,
      startRow: 1,
      endRow: 30,
      total: total,
      pages: 4,
      prePage: 0,
      nextPage: 2,
      isFirstPage: true,
      isLastPage: false,
      hasPreviousPage: false,
      hasNextPage: true,
      navigatePages: 8,
      navigatepageNums: [1, 2, 3, 4, 5, 6, 7, 8],
      navigateFirstPage: 1,
      navigateLastPage: 8,
      rows: []
    };
    let obj = {};

    if (payload.sortord === "descending" || payload.sortord === "ascending") {
      obj = Mock.mock({
        [`rows|${pageSize}`]: [
          {
            "id|1-100": 100,
            projectName: "@cname()",
            "procurementMethod|1-100": 100,
            "procurementMethodCode|1-100": 100,
            procurementPlanCode: "@cname()",
            biddingCode: "@cname()",
            "isFloatContractPrice|0-1": 1,
            floatDesc: "@cname()",
            quoteBiddingResult: "@cname()",
            quoteBiddingResult2: "@cname()",
            "tPcConcId|1-100": 100
          }
        ]
      });
    } else {
      obj = Mock.mock({
        [`rows|${pageSize}`]: [
          {
            "id|1-100": 100,
            projectName: "@cname()",
            "procurementMethod|1-100": 100,
            "procurementMethodCode|1-100": 100,
            procurementPlanCode: "@cname()",
            biddingCode: "@cname()",
            "isFloatContractPrice|0-1": 1,
            floatDesc: "@cname()",
            quoteBiddingResult: "@cname()",
            quoteBiddingResult2: "@cname()",
            "tPcConcId|1-100": 100
          }
        ]
      });
    }

    data.data.rows = obj.rows;
    data.data.pageNo = pageNo;
    data.data.recordsTotal = recordsTotal;
    data.code = "0";
    data.msg = "查询成功";
    data.attributes = "";
    data.errorDetail = "";
    return data;
  }
};
